import { RadioGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "RadioList";
var classes = {
    formControlLabel: "".concat(PREFIX, "-formControlLabel"),
    formGroup: "".concat(PREFIX, "-formGroup"),
    label: "".concat(PREFIX, "-label")
};
var StyledRadioList = styled(RadioGroup)(function () {
    var _a;
    return (_a = {},
        _a["& .".concat(classes.formControlLabel)] = {
            width: "100%",
            "& .MuiTypography-body1": {
                // 42px is the size of the checkbox
                width: "calc(100% - 42px)"
            }
        },
        _a);
});

export { classes, StyledRadioList as default };
//# sourceMappingURL=index.styled.js.map
